// extracted by mini-css-extract-plugin
module.exports = {"input":"CardIconInput_input__PuKzp","positionR":"CardIconInput_positionR__ExCXi"};